import { TextField } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DEFAULT_HOURS_PER_DAY } from "../format-utils"
import { MAX_HOURS_PER_DAY } from "routes/rate-cards/capacity-constants.mjs"
import { getHoursPerDayError } from "./working-time-validation"

export function WorkingTimeFields() {
    const { target, refresh } = useBoundContext()
    const hoursError = getHoursPerDayError(target.hoursPerDay)

    return (
        <TextField
            data-cy="hours-per-day"
            label="Hours per Day"
            type="number"
            value={target.hoursPerDay ?? ""}
            onChange={handleHoursPerDayChange}
            onWheel={(e) => e.target.blur()}
            fullWidth
            error={Boolean(hoursError)}
            helperText={hoursError || `Leave blank to use ${DEFAULT_HOURS_PER_DAY} hours`}
            inputProps={{ min: 0.01, max: MAX_HOURS_PER_DAY, step: 0.5 }}
            placeholder={`${DEFAULT_HOURS_PER_DAY}`}
        />
    )

    function handleHoursPerDayChange(e) {
        target.hoursPerDay = e.target.value
        refresh()
    }
}
